"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMOS = exports.isMONS = exports.isSOS = exports.isSONS = void 0;
function isSONS(value) {
    return typeof value === 'string';
}
exports.isSONS = isSONS;
function isSOS(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        return false;
    }
    for (const subfieldValue of Object.values(value)) {
        if (typeof subfieldValue !== 'string') {
            return false;
        }
    }
    return true;
}
exports.isSOS = isSOS;
function isMONS(value) {
    if (!Array.isArray(value)) {
        return false;
    }
    for (const e of value) {
        if (!isSONS(e)) {
            return false;
        }
    }
    return true;
}
exports.isMONS = isMONS;
function isMOS(value) {
    if (!Array.isArray(value)) {
        return false;
    }
    for (const e of value) {
        if (!isSOS(e)) {
            return false;
        }
    }
    return true;
}
exports.isMOS = isMOS;
//# sourceMappingURL=jfd-values.js.map